import { Project, UserRole } from "../../../../types"
import { TenantDetails } from "../../../store/tenant"
import { EditOperation } from "./EditOperation"
import { EditProject } from "./EditProject"
import { Button } from "@/components/button/Button"
import { useState } from "react"
import { ReImportProject } from "./ReImportProject"
import { reImportProject } from "../../../fetch/projects"
import { toast } from "react-toastify"
import { hasUserAccess } from "@/utils/user"
import { userState } from "@/store/user"
import { useWatcher } from "@/lib/state/useWatcher"
import { formatTimeDelta } from "@/lib/formatTimeDelta"

export const ProjectHeading = ({
  project,
  features,
  onSave,
  showEdit,
  showOpEdit,
}: {
  project: Project
  features: TenantDetails["settings"]["features"]
  onSave?: () => void
  showEdit?: boolean
  showOpEdit?: boolean
}) => {
  const user = useWatcher(userState)
  const [showReImport, setShowReImport] = useState(false)
  const progress = features["units"] ? project.progress : project.timeProgress
  const canEdit = hasUserAccess({
    neededRole: UserRole.Admin,
    userRole: user.role,
  })
  const canReImport = hasUserAccess({
    neededRole: UserRole.Admin,
    userRole: user.role,
  })

  const handleReImport = async (data: any) => {
    console.log(data)
    try {
      const response = await reImportProject(project.id.toString(), data)
      if (!response.ok) {
        throw new Error("Failed to re-import project")
      }
      toast.success("Project re-imported successfully")
      if (onSave) {
        onSave()
      }
    } catch (error) {
      toast.error("Failed to re-import project")
      console.error(error)
    } finally {
      setShowReImport(false)
    }
  }

  return (
    <div className="project-heading">
      <div className="title">
        {project.name}
        {project.code && <span>({project.code})</span>}
        {project.status === 6 && <span className="status">(Arhivēts)</span>}
      </div>
      <div className="info">
        {features["normatives"] ? (
          <span
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: project.difficulty > 100 ? "var(--error)" : undefined,
            }}
          >
            Normatīvi: {project.difficulty}%
          </span>
        ) : null}
        {features["units"] ? (
          <span>
            {project.unitsUsed} detaļas ({project.unitsPredicted})
          </span>
        ) : null}
        {features["time"] ? (
          <span>
            {formatTimeDelta(project.timeUsed)} (
            {formatTimeDelta(project.timePredicted)})
          </span>
        ) : null}
        {features["salary"] ? (
          <span>
            {project.salaryPredicted
              ? (project.salaryPredicted / 100).toFixed(2)
              : 0}
            €
          </span>
        ) : null}
        <span className="status">{progress}%</span>
        {showEdit && canEdit && (
          <EditProject project={project} onSave={onSave} />
        )}
        {showOpEdit && <EditOperation project={project} onSave={onSave} />}
        {canReImport && (
          <Button onClick={() => setShowReImport(true)}>Re-import</Button>
        )}
      </div>
      <div className="bar" style={{ width: `${progress}%` }} />
      {showReImport && (
        <ReImportProject
          onClose={() => setShowReImport(false)}
          onImport={handleReImport}
          projectId={project.id?.toString() ?? "0"}
        />
      )}
    </div>
  )
}
